<template>
  <div>
    <footer>
      <div class="content">
        <div class="container-fluid pt-5">
          <div class="row">
            <div class="col-12 blanco borderbottomazul">
              <div class="legal-text">
                <p>
                  Cemento Chihuahua pone la Troka 2026. Permiso otorgado por la
                  Secretaría de Gobernación con el número
                  <strong>20260135PS05</strong>. Vigencia del permiso del
                  <strong>6 de julio de 2026</strong> al
                  <strong>25 de septiembre de 2026</strong>. Vigencia de la
                  promoción del <strong>6 de julio de 2026</strong> al
                  <strong>13 de septiembre de 2026</strong>. Para participar en
                  el sorteo las personas deben realizar una compra mínima de
                  <strong>1 (uno) saco de Cemento Chihuahua</strong> en
                  cualquiera de sus presentaciones de
                  <strong>25kg y/o 50kg</strong>, de venta en los
                  establecimientos participantes en el estado de Chihuahua
                  durante la vigencia de la promoción y registrar sus tickets de
                  compra y datos en el sitio web
                  <a
                    href="https://www.cementochihuahua.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    >www.cementochihuahua.com</a
                  >. Promoción limitada a mayores de 18 años. No podrán
                  participar en el sorteo empleados y/o personal contratado y/o
                  pagado por cualquiera de las empresas pertenecientes a Grupo
                  Pauta Creativa, y a GCC CEMENTO, ni de otras empresas que
                  presten servicios a la misma, ni relacionadas con el
                  desarrollo del sorteo, ni personal administrativo y/o
                  empleados. Premio por otorgar: <strong>1 (uno)</strong>. Valor
                  de premio máximo de reposición:
                  <strong>$550,863.00</strong> (Quinientos cincuenta mil
                  ochocientos sesenta y tres pesos 00/100 MN). Fecha del sorteo:
                  <strong>25 de septiembre de 2026</strong>, a las
                  <strong>12:00 horas</strong>, en las oficinas de Grupo Pauta
                  Creativa, ubicadas en Berlín 318 Col. Del Carmen, Alcaldía
                  Coyoacán, C.P. 04100, Ciudad de México. El sorteo se realizará
                  ante la presencia del inspector, en el cual se presentará la
                  base de datos en Excel con el concentrado de participantes que
                  hayan cumplido con las bases de participación con los folios
                  únicos consecutivos para el sorteo. Contaremos con 5 urnas que
                  contendrán, cada una, esferas del 0 al 9, y se extraerá una
                  esfera de cada urna para formar el folio de participación
                  ganador. La formación del número de ganador se realizará de
                  derecha a izquierda, comenzando con la urna número 1
                  (unidades), urna 2 (decenas), urna 3 (centenas), urna 4
                  (unidades de millar), urna 5 (decenas de millar) y su lectura
                  de izquierda a derecha. En caso de que el número formado esté
                  fuera del rango de la emisión del número total de folios, el
                  premio volverá a sortearse. Los medios de difusión del sorteo
                  serán a través del sitio web
                  <a
                    href="https://www.cementochihuahua.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    >www.cementochihuahua.com</a
                  >. Los resultados del sorteo serán publicados en los diarios
                  impresos de circulación nacional
                  <strong>“El Heraldo de Chihuahua”</strong> y
                  <strong>“El Diario de Chihuahua”</strong> el día
                  <strong>27 de septiembre de 2026</strong>. La entrega de
                  premio se realizará ante la presencia de un inspector de la
                  Secretaría de Gobernación el
                  <strong>08 de octubre de 2026</strong>, a las
                  <strong>11:00 horas</strong>, en Boulevard Antonio Ortiz Mena
                  #431 Col. Unidad Presidentes, Chihuahua, Chihuahua, C.P.
                  31210. Responsable del sorteo: Grupo Pauta Creativa, ubicada
                  en Berlín 318 Col. Del Carmen, Alcaldía Coyoacán, C.P. 04100,
                  Ciudad de México, teléfono de contacto
                  <a href="tel:5550005200">55 5000 5200</a>. Los premios serán
                  pagados de conformidad con lo establecido en las bases del
                  sorteo. Para cualquier aclaración o información referente a
                  este sorteo o resultados del mismo, comunicarse al
                  <a href="tel:5594356588">55 9435 6588</a> de lunes a viernes
                  de 09:00 a 18:00 horas o al correo
                  <a href="mailto:contacto@cementochihuahua.com"
                    >contacto@cementochihuahua.com</a
                  >
                  y/o en la página de la promoción
                  <a
                    href="https://www.cementochihuahua.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    >www.cementochihuahua.com</a
                  >. Acceso libre y gratuito al evento del sorteo. En caso de
                  queja, acudir a la Dirección General de Juegos y Sorteos de la
                  Secretaría de Gobernación, ubicada en Versalles N° 49, Piso 2,
                  Col. Juárez, Alcaldía Cuauhtémoc, C.P. 06600, Ciudad de México
                  o bien comunicarse al teléfono:
                  <a href="tel:5552098800">55 5209 8800</a>.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid">
          <div class="row">
            <div class="col-12 pb-3 pt-5">
              <div class="row">
                <div class="col-6 text-left">
                  <a target="_blank" href="/tycos-2026.pdf" class="blanco terminos"
                    >Términos y Condiciones</a
                  >
                </div>
                <div class="col-6 text-right">
                  <span class="blanco">GCC 2026 v1.2</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mostrar: true,
    };
  },
  methods: {},
  mounted: function () {
    if (this.$route.name == "Dinamica") {
      this.mostrar = false;
    }
  },
};
</script>

